import { Link } from 'react-router-dom';
import type { TvShow } from '@/types/tv';

interface RankListProps {
  shows: TvShow[];
}

export default function RankList({ shows }: RankListProps) {
  return (
    <ol className="space-y-2">
      {shows.map((show, index) => (
        <li key={show.id}>
          <Link
            to={`/detail/${show.id}`}
            className="group flex items-center gap-3 p-2 rounded-md hover:bg-background-100 transition-colors cursor-pointer"
          >
            <span
              className={`w-6 text-center font-heading font-bold text-base ${
                index < 3 ? 'text-accent-500' : 'text-foreground-400'
              }`}
            >
              {index + 1}
            </span>
            <div className="w-10 shrink-0 aspect-[2/3] rounded overflow-hidden bg-background-200">
              <img
                src={show.poster}
                alt={`${show.title}海报`}
                title={`${show.title} - 高分榜`}
                className="w-full h-full object-top object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                {show.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">{show.tags.slice(0, 2).join(' · ')}</p>
            </div>
            <span className="font-heading font-bold text-accent-600 text-sm">{show.score.toFixed(1)}</span>
          </Link>
        </li>
      ))}
    </ol>
  );
}